"use client";

const PILLARS = [
  {
    title: "Ancrage Parisien",
    description:
      "Né à Paris en 2019, Hyper OR I célèbre la qualité du terroir local et accompagne plus de 320 producteurs français.",
    stat: "320",
    statLabel: "producteurs partenaires",
  },
  {
    title: "Vision SmarTest Capital",
    description:
      "Une ambition portée par SENE & DIA : faire de la grande distribution française un modèle d'excellence et d'innovation.",
    stat: "1",
    statLabel: "vision · SmarTest Capital",
  },
  {
    title: "Impact Social",
    description:
      "850 emplois directs, 60% de femmes, formation continue et programme d'apprentissage pour la jeunesse parisienne.",
    stat: "850",
    statLabel: "emplois directs · 60% femmes",
  },
];

export function AboutSection() {
  return (
    <section id="about" className="relative bg-ink text-cream py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 ink-gradient"></div>
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(circle at 50% 0%, rgba(200,162,74,0.18) 0%, transparent 60%)",
        }}
      ></div>

      <div className="relative mx-auto max-w-7xl px-6">
        {/* Header — maison SENE & DIA */}
        <div className="grid md:grid-cols-12 gap-10 md:gap-14 mb-16">
          <div className="md:col-span-4">
            <div className="flex items-center gap-4 mb-6">
              <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-gold/40">
                <span className="font-display italic text-gold text-2xl">S&amp;D</span>
              </span>
              <div>
                <div className="font-display text-cream text-2xl">SENE &amp; DIA</div>
                <div className="text-cream/50 text-[10px] tracking-[0.3em] uppercase mt-1">
                  SmarTest Capital
                </div>
              </div>
            </div>
            <p className="font-serif italic text-gold text-xl leading-relaxed">
              « Bâtir la France de demain par le commerce d&apos;excellence. »
            </p>
          </div>
          <div className="md:col-span-8">
            <div className="ornament-line mb-6">
              <span className="text-gold text-[11px] tracking-[0.35em] uppercase">
                La Maison SENE &amp; DIA
              </span>
            </div>
            <h2 className="font-display text-cream text-4xl md:text-5xl leading-[1.1]">
              Derrière Hyper OR I,
              <br />
              <span className="gold-text italic">une vision.</span>
            </h2>
            <p className="mt-6 text-cream/70 font-serif text-base md:text-lg leading-relaxed">
              SENE &amp; DIA est un groupe français indépendant, fondé sur une
              conviction simple : Paris mérite des lieux de commerce à la
              hauteur de son dynamisme et de son goût pour l&apos;élégance.
            </p>
            <p className="mt-4 text-cream/70 font-serif text-base md:text-lg leading-relaxed">
              SmarTest Capital, notre signature, traduit notre engagement :
              allier capital, intelligence et impact. Hyper OR I est le
              porte-étendard de cette vision. Inauguré en 2019 sur le boulevard
              Haussmann, il est devenu en quelques années le rendez-vous des
              familles parisiennes exigeantes, des chefs français et de la
              diaspora de passage.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href="#location"
                className="inline-flex items-center gap-3 px-6 py-3 rounded-full gold-gradient text-ink font-semibold tracking-[0.2em] uppercase text-xs gold-shadow hover:scale-[1.02] transition-transform"
              >
                Rejoindre l&apos;aventure
              </a>
              <a
                href="#location"
                className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-cream/30 text-cream hover:border-gold hover:text-gold transition-colors tracking-[0.2em] uppercase text-xs"
              >
                Visiter le magasin
              </a>
            </div>
          </div>
        </div>

        {/* 3 piliers */}
        <div className="grid sm:grid-cols-3 gap-6">
          {PILLARS.map((p, idx) => (
            <article
              key={idx}
              className="bg-cream/5 backdrop-blur-sm border border-cream/15 rounded-xl p-6 hover:border-gold/40 transition-colors"
            >
              <h3 className="font-display text-cream text-xl">{p.title}</h3>
              <p className="mt-3 text-cream/60 text-sm leading-relaxed font-serif">
                {p.description}
              </p>
              <div className="mt-5 pt-5 border-t border-cream/10">
                <div className="font-display text-gold text-3xl">{p.stat}</div>
                <div className="text-cream/50 text-[10px] tracking-[0.2em] uppercase mt-1">
                  {p.statLabel}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
